"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SketchPicker = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
  var _yield$import, SketchPicker;

  return _regenerator.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import('react-color');

        case 2:
          _yield$import = _context.sent;
          SketchPicker = _yield$import.SketchPicker;
          return _context.abrupt("return", {
            default: SketchPicker
          });

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));

var IdeationAddColor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeationAddColor, _Component);

  var _super = _createSuper(IdeationAddColor);

  function IdeationAddColor(props) {
    var _this;

    (0, _classCallCheck2.default)(this, IdeationAddColor);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      enablePicker: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "bodyClickHandler", function (e) {
      var ref = _this.root;

      if (!ref.contains(e.target)) {
        _this.setState({
          enablePicker: false
        });
      }
    });
    _this.bodyClickHandler = _this.bodyClickHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.root = null;
    return _this;
  }

  (0, _createClass2.default)(IdeationAddColor, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.enablePicker && !this.state.enablePicker) {
        document.addEventListener('click', this.bodyClickHandler);
      } else if (!nextState.enablePicker && this.state.enablePicker) {
        document.removeEventListener('click', this.bodyClickHandler);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      return (0, _preact.h)("div", {
        className: "form-group ideation-color-add-field-container ".concat(props.qaClasses || ''),
        "data-type": props.type,
        ref: function ref(root) {
          _this2.root = root;
        },
        onClick: function onClick() {
          return _this2.setState({
            enablePicker: true
          });
        }
      }, (0, _preact.h)("label", null, props.title), (0, _preact.h)("div", {
        className: classnames('form-group', 'form-control', 'ideation-color-add-container')
      }, (0, _preact.h)("span", {
        className: "ideation-add__color-visual"
      }, (0, _preact.h)("span", {
        style: {
          backgroundColor: props.selectedColor
        },
        className: "ideation-color-preview"
      }), (0, _preact.h)("span", null, props.selectedColor)), (0, _preact.h)("span", {
        className: "ideation-arrow-icon"
      }, (0, _preact.h)("i", {
        className: "icon-full-arrow-bottom"
      })), (0, _preact.h)("span", {
        className: "ideation-add__color-picker-container"
      }, state.enablePicker ? (0, _preact.h)(SketchPicker, {
        disableAlpha: true,
        color: props.selectedColor,
        presetColors: props.colors,
        onChangeComplete: function onChangeComplete(color) {
          return props.onCallback((0, _defineProperty2.default)({}, props.type, color.hex));
        }
      }) : null)));
    }
  }]);
  return IdeationAddColor;
}(_preact.Component);

var _default = IdeationAddColor;
exports.default = _default;